export default __webpack_public_path__ + "static/media/Seera-Labs-logo.7bb0edeb.svg";